import axios from 'axios';
import { API_BASE_URL } from '../config/api';

export interface YouTubeVideo {
  id: string;
  title: string;
  thumbnail: string;
  channelTitle: string;
  duration: string;
}

export interface SearchResult {
  videos: YouTubeVideo[];
  error: string | null;
}

// If we need to decode the title
function decodeHtmlEntities(text: string) {
  const textArea = document.createElement("textarea");
  textArea.innerHTML = text;
  return textArea.value;
}


export const searchYouTubeVideos = async (word: string): Promise<SearchResult> => {
  if (!word.trim()) {
    return { videos: [], error: null };
  }

  try {
    // First search for videos
    const searchResponse = await axios.post(`${API_BASE_URL}/youtube/${word}`, {
      timeout: 100000 // increase timeout to 10 seconds
    });

    return searchResponse.data
  } catch (error) {
    const errorMessage = error instanceof Error ? error.message : 'Failed to fetch videos for word ' + word;
    console.error(errorMessage);
    console.error(error);
    return { videos: [], error: 'Failed to fetch videos for word ' + word };
  }
};